/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: languagesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteLanguage } from './api/languageApi';

/**
 * Shared helpers for Languages module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Language in the form.
 * Pattern: /pbx/incoming-tools/languages/new?duplicate={id}
 */
export const getLanguageDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/languages/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Language id.
 */
export const navigateToLanguageDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getLanguageDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Language by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteLanguageById = async (id: string | number): Promise<void> => {
  await deleteLanguage(id);
};

